<template>
  <v-flex xs12 sm6 md6 lg4 xl3 px-2 mb-2>
    <v-hover>
      <v-card
        class="px-4 py-2 mb-2 rounded-3 team-card"
        color="cardBackground"
        slot-scope="{ hover }"
        :class="`elevation-${hover ? 5 : 2}`"
        v-if="cardAction"
        >
        <v-card-title class="pa-0 pb-2 pt-1">
            <v-flex xs12>
              <h3 class="icon-bold-link primary--text text-truncate mt-1 mb-1 pb-1 pr-3">{{cardContent.displayName}}</h3>
            </v-flex>
            <v-flex xs12 pr-4>
              <h4 class="text-truncate">
                <span class="primary--text body-1 opacity-54 pt-1">Members -</span>
                <span
                        class="pl-1 pt-1 primary-text body-1 opacity-54 font-weight-bold"
                      >{{ usersLengthCheck(cardContent.users) }} </span>
              </h4>
            </v-flex>
          </v-card-title>
        <v-card-actions v-if="cardAction" class="card-vert-menu">
          <v-btn flat icon v-if="addAction" color="success" class="ma-0" style="margin-top:calc(50% - 7px) !important; margin-left:-10px !important;" @click="addTeam(cardContent)">
            <v-icon >add_circle</v-icon>
          </v-btn>
          <v-btn flat icon v-if="!addAction" class="ma-0 " color="error" style="margin-top:calc(50% - 7px) !important; margin-left:-10px !important;" @click="removeTeam(cardContent)">
            <v-icon>remove_circle</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card
        class="px-4 py-2 mb-2 rounded-3 team-card"
        color="cardBackground"
        slot-scope="{ hover }"
        :class="`elevation-${hover ? 5 : 2}`"
        :to="route"
        v-else
        >
        <v-card-title class="pa-0 pb-2 pt-1">
            <v-flex xs12>
              <h3 class="icon-bold-link primary--text text-truncate mt-1 mb-1 pb-1 pr-3">{{cardContent.displayName}}</h3>
            </v-flex>
            <v-flex xs12 pr-4>
              <h4 class="text-truncate">
                <span class="primary--text body-1 opacity-54 pt-1">Members -</span>
                <span
                        class="pl-1 pt-1 primary-text body-1 opacity-54 font-weight-bold"
                      >{{ usersLengthCheck(cardContent.users) }} </span>
              </h4>
            </v-flex>
          </v-card-title>

          <v-card-actions v-if="cardAction" class="card-vert-menu">
          <v-btn flat icon v-if="addAction" color="success" class="ma-0" style="margin-top:calc(50% - 7px) !important; margin-left:-10px !important;" @click="addTeam(cardContent)">
            <v-icon >add_circle</v-icon>
          </v-btn>
          <v-btn flat icon v-if="!addAction" class="ma-0 " color="error" style="margin-top:calc(50% - 7px) !important; margin-left:-10px !important;" @click="removeTeam(cardContent)">
            <v-icon>remove_circle</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-hover>
  </v-flex>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: "TeamCard",
  data: () => ({

  }),
  props: ["cardContent", "cardAction"],
  computed: {
    ...mapState({
      user: state => state.users.currentlySelected.user
    }),
    route() { return "teams/" + this.cardContent.id + "/details" },
    addAction() { return (this.cardAction === "add") }
  },
  methods: {
    async addTeam(team) {
      await this.$store.dispatch("createTeamMembership", { teamId: parseInt(team.id), userId: parseInt(this.user.id) })
    },
    async removeTeam(team) {
      await this.$store.dispatch("deleteTeamMembership", { teamId: parseInt(team.id), userId: parseInt(this.user.id) })
    },
    usersLengthCheck(users) {
      if (!users || users.length < 1) return 0
      return users.length
    }
  }
}
</script>
